import * as React from 'react';

import formFields from '../Constants/formFields';
import IFormValue from '../Interfaces/IFormValue';
import FormState from '../Models/FormState';

interface IFormFieldsProps {
    formState: FormState;
    formValue: IFormValue;
}

const FormFields: React.FC<IFormFieldsProps> = ({formState, formValue}) => {
    return (
        <fieldset className="form-fields">
            {formFields.map(({type, name, placeholder}) => {
                const className = ['input', name === formState.activeField && 'input--active']
                    .filter(Boolean)
                    .join(' ');

                return (
                    <input
                        key={name}
                        className={className}
                        type={type}
                        value={formValue[name]}
                        readOnly
                        placeholder={placeholder}
                    />
                );
            })}
        </fieldset>
    );
};

export default FormFields;
